import type { Metric } from '../types';
import { SEED_IDS } from './ids';

/**
 * Canonical seed metrics, one per supported metric type.
 * Fixed UUIDs make bulkPut idempotent — re-seeding updates in place
 * without creating duplicates.
 */
export const SEED_METRICS: Metric[] = [
  {
    id: SEED_IDS.metrics.weight,
    name: 'Weight',
    type: 'number',
    unit: 'lb',
    icon: 'BarChartIcon',
    aggregationRule: 'latest',
    colorToken: '--aurora-rose',
    chartType: 'line',
    yAxisDomain: [140, 220],
  },
  {
    id: SEED_IDS.metrics.water,
    name: 'Water Intake',
    type: 'counter',
    unit: 'glasses',
    icon: 'BlendingModeIcon',
    aggregationRule: 'sum',
    colorToken: '--sage-mist',
    chartType: 'bar',
  },
  {
    id: SEED_IDS.metrics.mood,
    name: 'Mood',
    type: 'scale',
    icon: 'StarIcon',
    aggregationRule: 'average',
    colorToken: '--amber-glow',
    chartType: 'line',
    yAxisDomain: [1, 5],
  },
  {
    id: SEED_IDS.metrics.journal,
    name: 'Journal',
    type: 'media',
    icon: 'Pencil2Icon',
    aggregationRule: 'latest',
    colorToken: '--sage-mist',
    chartType: 'line',
  },
];
